// Derive the effective visual prominence for a release on the Timeline.
//
// Rules (matches SE6 in hub-critique.md):
//   1. Editor override wins (`visual_prominence` = 'minor' | 'normal').
//   2. Otherwise infer 'minor' when every item is bugfix/maintenance —
//      a release with no shipped user-facing work shouldn't compete
//      visually with a real feature launch.
//   3. Zero-item releases stay 'normal'; without evidence, don't demote.
import type { Release } from "@release-hub/shared";

export type Prominence = "minor" | "normal";

const MINOR_CATEGORIES = new Set(["bugfix", "maintenance"]);

export function effectiveReleaseProminence(release: Release): Prominence {
  if (release.visual_prominence === "minor") return "minor";
  if (release.visual_prominence === "normal") return "normal";
  const items = release.items ?? [];
  if (items.length === 0) return "normal";
  return items.every((it) => MINOR_CATEGORIES.has(it.category))
    ? "minor"
    : "normal";
}
